var ltr6_module_challenges = (function (ltr6_module_challenges) {
    
    ltr6_module_challenges.fadeSpeed = 0.1;

    ltr6_module_challenges.init = function(){

      // click handler
      $('#ltr6-wrapper').on('click', '.ltr6-trend-section-challenges a[data-challenges-link]', function(event) {
        event.preventDefault();
        // if($(this).hasClass('active')) return;
        // var slidesWrapper = $('.ltr6-challenges-slides');
        // var challengeClass = $(this).attr('data-challenges-link');
        // var challengeGroup = $(this).closest('.ltr6-trend-section-challenges');

        // var allLinks = challengeGroup.find('[data-challenges-link]');
        // var newLink = challengeGroup.find('[data-challenges-link="'+challengeClass+'"]');
        // var oldSlide = challengeGroup.find('.ltr6-challenges-block.active');
        // var allSlides = challengeGroup.find('.ltr6-challenges-block');
        // var newSlide = challengeGroup.find('.ltr6-challenges-block.'+challengeClass);

        // // set classes on the links
        // allLinks.removeClass('active');
        // newLink.addClass('active');
        // // // set classes on the slides
        // // allSlides.removeClass('active');
        // // newSlide.addClass('active');

        // // fade transition. to disable, uncomment the above and comment this below and tweens out.
        // slidesWrapper.css('height',slidesWrapper.height());
        // newSlide.css('opacity',0);
        // TweenLite.to(oldSlide,ltr6_module_challenges.fadeSpeed,{opacity:0,onComplete:function(){
        //   allSlides.removeClass('active');
        //   newSlide.addClass('active');
        //   var newSlideHeight = newSlide.prop('scrollHeight');
        //   TweenLite.to(newSlide,ltr6_module_challenges.fadeSpeed,{opacity:1});
        //   TweenLite.to(slidesWrapper,ltr6_module_challenges.fadeSpeed,{height:newSlideHeight,onComplete:function(){
        //     slidesWrapper.css('height','auto');
        //   }});
        // }});
        if($(this).hasClass('active')) return;
        var challengeClass = $(this).attr('data-challenges-link');
        var challengeGroup = $(this).closest('.ltr6-trend-section-challenges');
        var allLinks = challengeGroup.find('[data-challenges-link]');
        var newLink = challengeGroup.find('[data-challenges-link="'+challengeClass+'"]');
        allLinks.removeClass('active');
        newLink.addClass('active');

        $('#ltr6-wrapper .ltr6-challenges-block').removeClass('active');
        $('#ltr6-wrapper .ltr6-challenges-block.'+challengeClass+'').addClass('active');
      });


    };//end init

    return ltr6_module_challenges;
}(ltr6_module_challenges || {}));
